module.exports = __webpack_public_path__ + "img/bkground_portfolio_default.042e46f7.png";